/**
 * A file name a path pattern would match, for previews that need one: the
 * pattern's last segment with each wildcard filled in. `**\/*.csv` gives
 * `example.csv`; `**\/scream-*.csv` gives `scream-example.csv`.
 */
export function exampleFileNameFor(
  pattern: string | undefined,
  fallback: string,
): string {
  const segment = pattern?.split("/").pop()?.trim() ?? "";
  if (segment === "" || segment === "**") {
    return fallback;
  }
  const filled = segment
    .replace(/\*+/g, "example")
    .replace(/\?/g, "x")
    .replace(/\[[^\]]*\]/g, "x")
    .replace(/\{([^,}]*)[^}]*\}/g, "$1");
  return filled === "" ? fallback : filled;
}
